/**
 * ================================================================
 * PrettyBirds – Product Selector + Color Tab Bridge
 * File: assets/product-selector-prestige.js
 * ================================================================
 */

(function () {
  'use strict';

  /* Trạng thái collapse — tồn tại xuyên suốt mọi lần Prestige re-render */
  var _shouldCollapse = false;
  var _userExpanded   = false;

  /* ── Bind showAllBtn cho element mới sau mỗi lần replace ── */
  function bindShowAllBtn(wrapper) {
    var btn = wrapper.querySelector('.pb-show-all-btn');
    if (!btn || btn._pbBound) return;
    btn._pbBound = true;
    btn.addEventListener('click', function () {
      _userExpanded = true;
      wrapper.classList.remove('is-collapsed');
      btn.setAttribute('aria-expanded', 'true');
    });
  }

  /* ── Áp trạng thái collapse vào element (dùng sau mỗi re-render) ── */
  function applyCollapse(wrapper) {
    if (_shouldCollapse && !_userExpanded) {
      wrapper.classList.add('is-collapsed');
    }
    bindShowAllBtn(wrapper);
  }

  /* ── MutationObserver: catch ngay khi Prestige replaceWith liquid block ──
     Prestige gọi element.replaceWith(matchingBlock) cho mọi block type "liquid"
     → MutationObserver fire trong microtask TRƯỚC khi browser paint
     → add is-collapsed ngay lập tức → không có flash
  ── */
  function setupRerenderObserver() {
    var blockList = document.querySelector('.product-info__block-list');
    if (!blockList) return;

    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          /* node là block wrapper mới được Prestige insert */
          var group = (node.id === 'pb-product-group')
            ? node
            : node.querySelector && node.querySelector('#pb-product-group');
          if (group) applyCollapse(group);
        }
      }
    });

    obs.observe(blockList, { childList: true, subtree: true });
  }

  function init() {
    var swatchWrapper = document.getElementById('pb-product-group');
    if (!swatchWrapper) return;

    /* ── 1. Parse JSON data block ── */
    var colorMap = {};
    try {
      var dataEl = document.getElementById('pb-product-group-data');
      if (dataEl) {
        var products = JSON.parse(dataEl.textContent).products || [];
        products.forEach(function (p) {
          colorMap[p.url] = {
            name:  p.color      || '',
            desc:  p.colorDesc  || '',
            image: p.colorImage || ''
          };
        });
      }
    } catch (e) {
      console.warn('[PrettyBirds] JSON parse error:', e);
    }

    /* ── 2. DOM refs ── */
    var styleTabs  = swatchWrapper.querySelectorAll('.pb-tab');
    var swatches   = swatchWrapper.querySelectorAll('.pb-swatch');
    var swatchList = swatchWrapper.querySelector('.pb-swatch-list');
    var topLabel   = document.getElementById('pb-current-color');

    /* ── 3. Style tab filter ── */
    styleTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        styleTabs.forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var style = tab.dataset.style;
        swatches.forEach(function (sw) {
          sw.style.display = (style === 'all' || sw.dataset.style === style) ? '' : 'none';
        });
      });
    });

    /* ── 4. Dispatch helper ── */
    function dispatchColorChange(data) {
      document.dispatchEvent(new CustomEvent('pb:colorChange', {
        bubbles: true,
        detail: {
          name:  data.name  || '',
          desc:  data.desc  || '',
          image: data.image || ''
        }
      }));
    }

    /* ── 5. Swatch hover / focus → preview tên màu ── */
    swatches.forEach(function (sw) {
      sw.addEventListener('mouseenter', function () {
        var data = colorMap[sw.getAttribute('href')];
        if (data && topLabel) topLabel.textContent = data.name;
      });
      sw.addEventListener('focus', function () {
        var data = colorMap[sw.getAttribute('href')];
        if (data && topLabel) topLabel.textContent = data.name;
      });
    });

    if (swatchList) {
      swatchList.addEventListener('mouseleave', function () {
        var active = swatchWrapper.querySelector('.pb-swatch.is-active');
        if (active) {
          var data = colorMap[active.getAttribute('href')];
          if (data && topLabel) topLabel.textContent = data.name;
        }
      });
    }

    /* ── 6. Swatch click ── */
    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        var url  = sw.getAttribute('href');
        var data = colorMap[url];
        if (!data || !data.name) return;
        if (topLabel) topLabel.textContent = data.name;
        dispatchColorChange(data);
      });
    });

    /* ── 7. Init active swatch ── */
    var activeSwatch = swatchWrapper.querySelector('.pb-swatch.is-active');
    if (activeSwatch) {
      var initData = colorMap[activeSwatch.getAttribute('href')];
      if (initData) {
        if (topLabel) topLabel.textContent = initData.name;
        dispatchColorChange(initData);
      }
    }

    /* ── 8. Collapse: đo scrollHeight ngay tại DOMContentLoaded ──
       Ảnh swatch có width/height attribute → browser reserve space ngay,
       không cần đợi window.load → _shouldCollapse đúng trước lần click đầu tiên.
    ── */
    function measureAndCollapse() {
      if (_shouldCollapse) return;
      var h = swatchWrapper.scrollHeight;
      if (h > 175) {
        _shouldCollapse = true;
        swatchWrapper.classList.add('is-collapsed');
      }
      bindShowAllBtn(swatchWrapper);
    }

    measureAndCollapse();

    /* ── 9. Setup observer để catch Prestige re-render ── */
    setupRerenderObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
